module.exports = __webpack_public_path__ + "img/image_placeholder.16f109f8.jpg";